import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ImageWithContentLeftForProduct from "@/components/elements/ImageWithContent/ImageWithContentLeftForProduct";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import Table from "@/components/elements/Table/Table";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import vistasupercreteImg from '@/assets/images/products/vistasupercrete.png';

// Animation variants
const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const VistaSuperCrete = () => {
  return (
    <div className=" 2xl:px-40 xl:px-40 md:px-[3rem] sm:px-5 my-[4rem] ">
      <TitleBar
        title="Vista Super Crete"
        subTitle="An acrylic polymer-based protective cementitious coating for waterproofing and repairing compounds"
      />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeftForProduct alt="Vista Super Crete"
          title="Description"
          imageUrl={vistasupercreteImg}
          content="Vista Super Crete is an acrylic polymer-based cementitious coating and repairing compound. When used as recommended, it combines with cement and fine sand to form an impermeable coating by blocking the capillaries and pores of the concrete substrate. It is also UV resistant."
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Uses">
          <Paragraph content="Vista Super Crete is recommended for use in infrastructures that require waterproofing and protection against the ingress of moisture, like roofs, terraces, basements, water tanks, swimming pools, retaining walls, bridge walls, tunnels, sewage tanks, reservoirs, joms, dock gates, etc." />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages">
          <CustomLists
            items={[
              [
                "Excellent bond with most building materials.",
                "Low permeability makes mortar or concrete waterproof.",
                "Imparts chemical resistance to substrate.",
              ],
              [
                "Reduces or prevents salt penetration into concrete and mortar.",
                "Non-toxic and can be used in water tanks.",
                "Eco-friendly, harmless to workers.",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Properties">
          <Table
            items={{
              headings: [],
              rows: [
                ["Form", "Milky White Liquid"],
                ["Specific Gravity", "1.03 ± 0.02"],
                ["pH", "7 - 9"],
                ["Chloride", "NIL (as per BS : 5075, Part - 1)"],
              ],
            }}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Handling Precautions">
          <Paragraph content="Vista Super Crete is non-toxic, but prolonged skin contact should be avoided. In case of contact with eyes, wash with plenty of clean water and seek medical advice. Cleaning of tools should be done with water." />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default VistaSuperCrete;
